<template>
  <b-modal id="org-logins" size="lg" centered hide-footer hide-header>
    <div class="d-flex align-items-center mb-3">
      <h3 class="d-inline mr-auto">Organization Logins</h3>
      <b-btn variant="outline-primary" @click="exportCSV">
        <i class="icon-cloud-download" /> Export CSV
      </b-btn>
    </div>
    <b-form-row class="mb-2">
      <b-col>
        <label>
          Search
          <b-input
            v-model="search"
            debounce="500"
            placeholder="search..."
            type="search"
          />
        </label>
      </b-col>
      <b-col>
        <label>
          Status
          <b-select
            v-model="reason"
            :options="[
              { text: 'All', value: '' },
              { text: 'Success', value: 'success' },
              { text: 'Invalid Password', value: 'invalid-pass' },
              { text: 'IP Not Allowed', value: 'ip-not-allowed' }
            ]"
          />
        </label>
      </b-col>
      <b-col>
        <label>
          Before
          <b-datepicker
            v-model="before"
            :date-format-options="{
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            }"
            reset-button
          />
        </label>
      </b-col>
    </b-form-row>
    <div class="overflow-auto">
      <b-table
        class="text-nowrap"
        :fields="fields"
        :items="getLogins"
        :filter="[before, reason, search]"
        :per-page="10"
        :current-page="page"
        :busy="loading"
        show-empty
      >
        <template #table-busy>
          <div class="py-5 text-center">
            <b-spinner />
          </div>
        </template>

        <template #cell(from)="{ item }">
          <span>{{ item.from || "-" }}</span>
        </template>

        <template #cell(source)="{ item }">
          <span>{{ parseSource(item.source) }}</span>
        </template>

        <template #cell(reason)="{ item }">
          <b-badge
            :variant="item.reason.includes('success') ? 'success' : 'danger'"
          >
            {{ parseReason(item.reason) }}
          </b-badge>
        </template>

        <template #cell(created_time)="{ item }">
          <span v-b-tooltip="new Date(item.created_time).toLocaleString()">
            {{ item.created_time | date }}
          </span>
        </template>
      </b-table>
    </div>

    <b-pagination
      v-if="total > 10"
      v-model="page"
      :total-rows="total"
      :per-page="10"
      align="center"
      class="mb-4"
      prev-text="Prev"
      next-text="Next"
      hide-goto-end-buttons
    />
  </b-modal>
</template>

<script>
import API from "@/api";
import { downloadText } from "@/helpers/download";

export default {
  props: {
    org: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    loading: false,
    fields: [
      { key: "name", label: "Name" },
      { key: "email", label: "Email" },
      { key: "reason", label: "Status" },
      { key: "from", label: "IP" },
      { key: "source", label: "Source" },
      { key: "created_time", label: "Time" }
    ],
    before: "",
    reason: "",
    search: "",
    page: 1,
    total: 0
  }),

  methods: {
    async exportCSV() {
      const { success, results } = await API.getOrgLogins({
        org_id: this.org.id,
        count: 100000
      });
      if (!success) return;

      const lines = ["name,email,status,ip,source,time"];
      lines.push(
        ...results.results.map(item => {
          return [
            item.name,
            item.email,
            this.parseReason(item.reason),
            item.from,
            this.parseSource(item.source),
            item.created_time
          ].join(",");
        })
      );

      downloadText(`${this.org.name} audit log.csv`, lines.join("\n"));
    },

    async getLogins(ctx) {
      this.loading = true;
      const { success, results } = await API.getOrgLogins({
        org_id: this.org.id,
        before: this.before,
        reason: this.reason,
        search: this.search,
        page: ctx.currentPage - 1,
        count: ctx.perPage
      });
      this.loading = false;
      if (!success) return [];
      this.total = results.total;
      return results.results;
    },

    parseReason(reason) {
      const reasons = {
        success: "Success",
        "invalid-login": "Invalid Login",
        "invalid-pass": "Invalid Password",
        "ip-not-allowed": "IP Not Allowed"
      };
      return reasons[reason.slice(reason.indexOf(":") + 1)] || "Unknown";
    },

    parseSource(source) {
      if (source.startsWith("web")) return "Web";
      if (source.startsWith("api")) return "Nanome";
      return "Other";
    }
  }
};
</script>
